import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import DummyOutput from './DummyOutput'
import { getUSADefault } from '../../Wizard2/selectOptions'

const DummyApostilleDetails = () => {
  const {
    recordDetailConfig: { sourceTypeConfig, historyConfig = {} },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <div>
      <div
        className="row"
        style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginBottom: '20px' }}
      >
        <DetailCard className="detailsCard" label="Apostille" style={{ flexGrow: '1' }}>
          <div className="dummy-card">
            <div className="dummy-card-col">
              <DummyOutput
                accessor="SignedBy"
                info={sourceTypeConfig.SignedBy || {}}
                outputFormat="N012345678"
              />
              <DummyOutput
                accessor="ApostilleNum"
                info={sourceTypeConfig.ApostilleNum || {}}
                outputFormat="000000001"
              />
              <DummyOutput
                accessor="LegacyControlNum"
                info={sourceTypeConfig.LegacyControlNum || {}}
                outputFormat="L00000001"
              />
              <DummyOutput
                accessor="NotaryNum"
                info={sourceTypeConfig.NotaryNum || {}}
                outputFormat="1234567"
              />
              <DummyOutput
                accessor="NotaryName"
                info={sourceTypeConfig.NotaryName || {}}
                outputFormat="First Last"
              />
              <DummyOutput
                accessor="Country"
                info={sourceTypeConfig.Country || {}}
                outputFormat={getUSADefault()}
              />
              <DummyOutput
                accessor="County"
                info={sourceTypeConfig.County || {}}
                outputFormat="Orange County"
              />
              <DummyOutput
                accessor="ActingCapacity"
                info={sourceTypeConfig.ActingCapacity || {}}
                outputFormat="Secretary"
              />
              <DummyOutput
                accessor="ImageNum"
                info={sourceTypeConfig.ImageNum || {}}
                outputFormat="B1234-1234"
              />
              <DummyOutput
                accessor="ReceivedDate"
                info={sourceTypeConfig.ReceivedDate || {}}
                outputFormat="MM/dd/yyyy"
              />
              <DummyOutput
                accessor="CreatedDate"
                info={sourceTypeConfig.CreatedDate || {}}
                outputFormat="MM/dd/yyyy"
              />
              <DummyOutput
                accessor="Status"
                info={sourceTypeConfig.Status || {}}
                outputFormat="Approved"
              />
            </div>
          </div>
        </DetailCard>
        <DetailCard className="detailsCard" label="Requestor Information" style={{ flexGrow: '1' }}>
          <div className="dummy-card">
            <div className="dummy-card-col">
              <DummyOutput
                accessor="DocumentType"
                info={sourceTypeConfig.DocumentType || {}}
                outputFormat="Certified"
              />
              <DummyOutput
                accessor="ContactName"
                info={sourceTypeConfig.ContactName || {}}
                outputFormat="First Last"
              />
              <DummyOutput
                accessor="ContactPhone"
                info={sourceTypeConfig.ContactPhone || {}}
                outputFormat="(123)456-7890"
              />
              <DummyOutput
                accessor="ContactCountry"
                info={sourceTypeConfig.ContactCountry || {}}
                outputFormat={getUSADefault()}
              />
              <DummyOutput
                accessor="ContactAddress"
                info={sourceTypeConfig.ContactAddress || {}}
                outputFormat="Address"
              />
            </div>
          </div>
        </DetailCard>
        <DetailCard
          className="historyDetailsCard"
          label="Apostille Filing History Config"
          style={{ flexGrow: '1' }}
        >
          <div className="dummy-card history">
            <div className="dummy-card-col">
              <DummyOutput
                accessor="Type"
                info={historyConfig.Type || {}}
                outputFormat="Initial Filing"
                isHistory
              />
              <DummyOutput
                accessor="ApostilleNumber"
                info={historyConfig.ApostilleNumber || {}}
                outputFormat="000000001"
                isHistory
              />
              <DummyOutput
                accessor="LegacyDocumentNum"
                info={historyConfig.LegacyDocumentNum || {}}
                outputFormat="L00000001"
                isHistory
              />
              <DummyOutput
                accessor="ReceivedDate"
                info={historyConfig.ReceivedDate || {}}
                outputFormat="MM/dd/yyyy"
                isHistory
              />
              <DummyOutput
                accessor="ProcessedDate"
                info={historyConfig.ProcessedDate || {}}
                outputFormat="MM/dd/yyyy"
                isHistory
              />
              <DummyOutput
                accessor="DocNumber"
                info={historyConfig.DocNumber || {}}
                outputFormat="B1234-1234"
                isHistory
              />
              <DummyOutput
                accessor="ReceiptNum"
                info={historyConfig.ReceiptNum || {}}
                outputFormat="00000001"
                isHistory
              />
              <DummyOutput
                accessor="ReceiptAmount"
                info={historyConfig.ReceiptAmount || {}}
                outputFormat="$0.00"
                isHistory
              />
              <DummyOutput
                accessor="Status"
                info={historyConfig.Status || {}}
                outputFormat="Approved"
                isHistory
              />
              <DummyOutput
                accessor="CreatedBy"
                info={historyConfig.CreatedBy || {}}
                outputFormat="First Last"
                isHistory
              />
              <DummyOutput
                accessor="LastModifiedBy"
                info={historyConfig.LastModifiedBy || {}}
                outputFormat="First Last"
                isHistory
              />
              <DummyOutput
                accessor="ProcessedByUser"
                info={historyConfig.ProcessedByUser || {}}
                outputFormat="First Last"
                isHistory
              />
              <DummyOutput
                accessor="VoidInfo"
                info={historyConfig.VoidInfo || {}}
                outputFormat="(button)"
                isHistory
              />
              <DummyOutput
                accessor="Correspondence"
                info={historyConfig.Correspondence || {}}
                outputFormat="(downloads)"
                isHistory
              />
            </div>
          </div>
        </DetailCard>
      </div>
    </div>
  )
}

export default DummyApostilleDetails
